export const GET_ZONES_ERROR = "Une erreur est survenue lors du chargement des zones.";
export const ADD_ZONE_ERROR = "Une erreur est survenue lors de l'ajout de la zone.";
export const DELETE_ZONE_ERROR = "Une erreur est survenue lors de la suppression de la zone.";
export const UPDATE_ZONE_ERROR = "Une erreur est survenue lors de la modification de la zone.";

export const GET_ZONE_ITEMS_ERROR = "Une erreur est survenue lors du chargement du contenu des zones.";

export const UPDATE_ZONE_ITEMS_COORDS_ERROR = "Une erreur est survenue lors de la mise à jour des coordonnées de l'objet.";


// WEBPACK FOOTER //
// ./src/errors/zones.js